export const PRODUCT_ZONE_FILTER = {
  ON_SALE: 'onSale',
  BWARE: 'bware',
} as const;

export type ProductZoneFilter = ValueOf<typeof PRODUCT_ZONE_FILTER>;
